import { render, staticRenderFns } from "./GroupInfoLocation.vue?vue&type=template&id=1283b0ac"
import script from "./GroupInfoLocation.vue?vue&type=script&lang=js"
export * from "./GroupInfoLocation.vue?vue&type=script&lang=js"
import style0 from "./GroupInfoLocation.vue?vue&type=style&index=0&id=1283b0ac&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports